import { Entity } from '@data-client/rest';
class EncryptionGeofencingCountryEntity extends Entity {
    constructor() {
        super(...arguments);
        this.countryCode = null;
        this.encryptionGeofencingCountryId = null;
        this.encryptionId = 0;
        this.geoCountryId = 0;
        this.isBlocked = null;
        this.name = null;
    }
    pk() {
        if (this.encryptionGeofencingCountryId) {
            return this.encryptionGeofencingCountryId.toString();
        }
        return `${this.encryptionId}:${this.geoCountryId}`;
    }
}
EncryptionGeofencingCountryEntity.key = 'EncryptionGeofencingCountry';
export { EncryptionGeofencingCountryEntity };
